import { environment } from "environments/environment";
export class ImageService {
  public typeSize = {
    large: "large",
    medium: "medium",
    original: "original",
    small: "small",
    thumb_large: "thumb_large",
    thumb_medium: "thumb_medium",
    thumb_small: "thumb_small"
  };

  public readSrcImage = function (prefix, size) {
    let url_image = "";
    if (prefix) {
      if(prefix.includes("http")){
        url_image = prefix;
      }else if(prefix.includes("TheHulk")){
        url_image = environment.url_static_image + "/" + prefix + ".jpg";
      }else{
        url_image = environment.url_static_image_id + "/" + prefix;
      }
    }
    return url_image;
  };
  public getFrefixFromUrl = function(src) {
    if (src) {
      console.log('src',src)
      let prefix1 = "";
      let checkHulk = src.split("-TheHulk")[1];
      if (checkHulk) {
        prefix1 += "-TheHulk" + checkHulk;
      }
      let prefix2 = "";

      let thumb_large = prefix1.indexOf("_thumb_large");
      if (thumb_large >= 0) {
        prefix2 = prefix1.slice(0, thumb_large);
        return prefix2;
      }
      let thumb_medium = prefix1.indexOf("_thumb_medium");
      if (thumb_medium >= 0) {
        prefix2 = prefix1.slice(0, thumb_medium);
        return prefix2;
      }
      let thumb_small = prefix1.indexOf("_thumb_small");
      if (thumb_small >= 0) {
        prefix2 = prefix1.slice(0, thumb_small);
        return prefix2;
      }
      let large = prefix1.indexOf("_large");
      if (large >= 0) {
        prefix2 = prefix1.slice(0, large);
        return prefix2;
      }
      let medium = prefix1.indexOf("_medium");
      if (medium >= 0) {
        prefix2 = prefix1.slice(0, medium);
        return prefix2;
      }
      let original = prefix1.indexOf("_original");
      if (original >= 0) {
        prefix2 = prefix1.slice(0, original);
        return prefix2;
      }
      let small = prefix1.indexOf("_small");
      if (small >= 0) {
        prefix2 = prefix1.slice(0, small);
        return prefix2;
      }
      return src;

    }
    return "";
  };
}



// WEBPACK FOOTER //
// /app/src/app/pages/imageService.ts